/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MUIDataTable from 'mui-datatables';
import Button from '@material-ui/core/Button';
import { TabContext, TabPanel } from '@material-ui/lab';
import { Tab, Tabs } from '@material-ui/core';
import {
  COLUMN,
  COLUMN_POINTS,
  COMLUMNOFFERS,
  createTripDetail,
  createOffers,
  createInventories,
  GET_COLUMN,
  OPTIONS,
} from './utils';
import { RatingApi, TripClient, PlaceDetails } from '../../services/api';
import { AppContextType, useApp } from '../../context/AppContext';
import ReviewComponent from 'components/UserDetail/components/reviews/Reviews';
import { createReviewsFromData } from 'components/UserDetail/utils';
import { getVerificationStatusText } from 'models/util';

const TripDetail = (): JSX.Element => {
  const { t } = useTranslation();
  const { changeRating, deleteRating } = RatingApi();

  const history = useHistory();
  const { id } = useParams();
  const { getTripById, getTripInventoryById, getReviewsByTripId, getOffersByTripId, deleteTrip } = TripClient();
  const { getPlaceDetails } = PlaceDetails();
  const { baggages } = useApp() as AppContextType;
  const [inventory, setInventory] = useState([]);

  const [data, setData] = useState<any[]>([]);
  const [shifterId, setShifterId] = useState<number>();
  const [offers, setOffers] = useState([]);
  const [value, setValue] = React.useState('1');
  const [industrialPoints, setIndustrialPoints] = useState<any[]>([]);
  const [reviews, setReviews] = useState([]);
  const [carId,setCarId] = useState('');
  const handleChange = (event: any, newValue: string) => {
    setValue(newValue);
  };
  const getIntervalPointsByPlaceIds = (detailTrip: any) => {
    return detailTrip?.intervalPoints && Promise.all(
      detailTrip.intervalPoints.map((point: string) => getPlaceDetails(point))
    );
  }

  useEffect(() => {
    (async () => {
      const detailTrip = await getTripById(id);
      const offers = await getOffersByTripId(id);
      const locationFrom = await getPlaceDetails(detailTrip.fromPlaceId);
      const locationTo = await getPlaceDetails(detailTrip.toPlaceId);
      detailTrip?.shifter && setShifterId(detailTrip.shifter.id);
      Promise.all([locationFrom, locationTo]).then((res) => {
        detailTrip.addressFrom = res[0].fullAddress;
        detailTrip.addressTo = res[1].fullAddress;
        detailTrip.verificationStatus = t(getVerificationStatusText(detailTrip.verificationStatus));
        detailTrip.offers = offers;
        setOffers(createOffers(detailTrip, t) ?? []);
        setCarId(detailTrip?.carId);
        setData(createTripDetail(detailTrip, baggages, t));
      });
      const intervalPoints: Array<string> = await getIntervalPointsByPlaceIds(detailTrip) ?? [];
      setIndustrialPoints(intervalPoints);
      const inventoryData = await getTripInventoryById(id) ?? [];
      const reviews = await getReviewsByTripId(id);
      setReviews(createReviewsFromData(reviews?.ratings) ?? []);
      setInventory(createInventories(inventoryData));
    })();
  }, [baggages, t]);

  const changeReview = async (data) => {
    await changeRating(data);
    const reviews = await getReviewsByTripId(id);
    setReviews(createReviewsFromData(reviews))
  }

  const deleteReview = async (id: number) => {
    await deleteRating(id);
    const reviews = await getReviewsByTripId(id);
    setReviews(createReviewsFromData(reviews))
  }

  return (
    <React.Fragment>
      <div>
        <h1 style={{ textAlign: 'center' }}>{t('trip')}</h1>

        <div
          style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: '20px' }}>
          <div style={{ width: '40%', marginRight: '2%' }}>
            <MUIDataTable
              title={''}
              data={data.slice(0, 7)}
              columns={COLUMN(t, shifterId)}
              options={OPTIONS(t)}
            />
          </div>
          <div style={{ width: '40%', marginLeft: '2%' }}>
            <MUIDataTable
              title={''}
              data={data.slice(7, data.length)}
              columns={COLUMN(t, carId)}
              options={OPTIONS(t)}
            />
          </div>
        </div>
      </div>
      <div style={{ margin: '20px auto' }}>
        <Button variant='outlined' onClick={() => history.goBack()}>
          {t('back')}
        </Button>
      </div>
      <div style={{ width: '100%', margin: '30px' }}>
        <TabContext value={value}>
          <Tabs value={value} onChange={handleChange} textColor='primary' indicatorColor='primary'>
            <Tab value='1' label={`${t('orders')} (${offers.length})`} />
            <Tab value='2' label={`${t('reviews')} (${reviews.length})`} />
            <Tab value='3' label={`${t('invetory')} (${inventory.length})`} />
            <Tab value='4' label={`${t('industrialPoints')} (${industrialPoints.length})`} />
          </Tabs>
          <TabPanel value='1'>
            <MUIDataTable
              title={''}
              data={offers}
              columns={COMLUMNOFFERS(t)}
              options={OPTIONS(t)}
            />
           
          </TabPanel>
          <TabPanel value='2'>
            <ReviewComponent
              data={reviews}
              changeReview={changeReview}
              deleteReview={deleteReview}
            />
          </TabPanel>
          <TabPanel value='3'>
              <MUIDataTable
                title={''}
                data={inventory}
                columns={GET_COLUMN(t)}
                options={{...OPTIONS(t),  
                   }}
              />
            </TabPanel>
            <TabPanel value='4'>
              <MUIDataTable
                title={''}
                data={industrialPoints}
                columns={COLUMN_POINTS(t)}
                options={{...OPTIONS(t),  
                   }}
              />
            </TabPanel>
        </TabContext>
      </div>
    </React.Fragment>
  );
};

export default TripDetail;
